import Axios from "axios";
import toast from "react-hot-toast";
import Emitter from "@core/helper/Emitter";

const BASE_URL = process.env.REACT_APP_API_URL;

const axiosInstance = Axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem("@userData");
    if (userData) {
      const data = JSON.parse(userData);
      if (data && data?.data?.token) {
        config.headers.token = data?.data?.token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const getFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};

const APICall = async (
  method = "post",
  body,
  url = null,
  headers = null,
  formData = false
) => {
  method = method.toLowerCase();
  const config = {
    method,
    timeout: 1000 * 60 * 2,
  };
  if (url) {
    config.url = url;
  }
  // if (body && method === 'get') {
  //   config.params = body
  // } else
  if (body && method === "post" && formData) {
    config.data = getFormData(body);
  } else {
    config.data = body;
  }
  if (headers) {
    config.headers = headers;
  }

  return new Promise((resolve) => {
    axiosInstance(config)
      .then((res) => resolve({ status: res.status, data: res.data }))
      .catch((error) => {
        if (error.response) {
          const errorMesg = error.response?.data?.message;
          if (
            error.response.status === 502 ||
            error.response.status === 500 ||
            error.response.status === 404
          ) {
            toast.error(`${errorMesg}`, {
              duration: 2000,
            });
          }
          else if (
            error.response.status === 401 &&
            error.response.data?.message === "Invalid token"
          ) {
            toast.error('Session Expired!', {
              duration: 2000,
            });
            Emitter.emit('logout')
          }
          // if (error.response.data?.message !== 'Invalid token.') {
          //   Utility.showToast(error.response.data.message, Const.toast.error)
          // }

          resolve({
            statusCode: error.response.status,
            data: error.response.data,
          });
          return;
        }
        if (error.code === "ECONNABORTED") {
          //   Utility.showToast(
          //     'Request timeout. Please check your internet connection',
          //     Const.toast.error
          //   )
          resolve({ statusCode: 400 });
          return;
        }

        // Utility.showToast('Something went wrong, Please try again later.', Const.toast.error)
        resolve({ status: 400 });
      });
  });
};

export default APICall;
